/**
 * @author sacotools
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';

import store from './store';

import 'normalize.css';
import './antd.less';
import './index.scss';
import './notifications.scss';

import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import Home from './components/home/Home';
import Musician from './components/musician/Musician';
import MyAccount from './components/my-account/MyAccount';

import SignUp from './components/sign-up/SignUp';
import SignIn from './components/sign-in/SignIn';
import Recover from './components/recover/Recover';
import Logout from './components/logout/Logout';
import NotFound from './components/not-found/NotFound';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { getEnv } from './utils/common';

const stripePK = {
  development: 'pk_test_ldX4NZv7Q07w8vvJtgyuGIkU003au1Q74E',
  staging: 'pk_test_ldX4NZv7Q07w8vvJtgyuGIkU003au1Q74E',
  production: 'pk_live_PCurzJXUjco3BGZzKndmijz400D8CkJE7k',
};

console.log('env:', getEnv());
const stripePromise = loadStripe(stripePK[getEnv()]);

// import FAQ from './components/faq/Faq';

// Layout component that includes Header and Footer
function Layout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <SignUp />
      },
      {
        path: "/u/:slug",
        element: <Musician />
      },
      {
        path: "/signup",
        element: <SignUp />
      },
      {
        path: "/signin",
        element: <SignIn />
      },
      {
        path: "/recover/:recoveryToken?",
        element: <Recover />
      },
      {
        path: "/recover",
        element: <Recover />
      },
      {
        path: "/my-account/*",
        element: <MyAccount />
      },
      {
        path: "/logout",
        element: <Logout />
      },
      {
        path: "*",
        element: <NotFound />
      }
    ]
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Elements stripe={stripePromise}>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </Elements>
);
